const lisfHall = (ajaxinstance) => {
  const api = {}

  api.getSysCountryCode = () => ajaxinstance({
    method: 'GET',
    url: '/v1/lisfHall/country-code',
  })

  api.getLifeUserInfo = token => ajaxinstance({
    method: 'GET',
    url: `/activity/userinfo/${token}`,
  })

  api.deleteUGC = (activityID, answerID) => ajaxinstance({
    method: 'POST',
    url: `/activity/ugc/${activityID}/answer/${answerID}/delete`,
  })

  api.getUGCInfo = (activityID, answerID) => ajaxinstance({
    method: 'GET',
    url: `/activity/ugc/${activityID}/answer/${answerID}`,
  })

  api.getUGCList = activityID => ajaxinstance({
    method: 'GET',
    url: `/activity/ugc/${activityID}/questions`,
  })

  api.submitUGCQusetion = data => ajaxinstance({
    method: 'POST',
    url: `/activity/ugc/${data.activityID}/question/${data.questionID}/answer`,
    data,
    headers: {
      user_code: '2221212t2222222',
    },
  })

  api.getUGCQusetionList = (activityID, questionID) => ajaxinstance({
    method: 'GET',
    url: `/activity/ugc/${activityID}/question/${questionID}/answers`,
  })

  api.getUGCQusetionStatus = (activityID, questionID) => ajaxinstance({
    method: 'GET',
    url: `/activity/ugc/${activityID}/question/${questionID}/answered`,
  })

  return api
}

export default lisfHall
